import React from 'react';

import FormSection from './form-section/FormSection';
import AdjustedMessages from './adjusted-messages/AdjustedMessages';

import scss from './Adjust.module.scss';

function Adjust() {
  return (
    <div className={scss.wrapper}>
      <FormSection />
      <AdjustedMessages />
    </div>
  );
}

export default Adjust;
